import { render, staticRenderFns } from "./RecommendationCompany.vue?vue&type=template&id=91432256&scoped=true&"
import script from "./RecommendationCompany.vue?vue&type=script&lang=js&"
export * from "./RecommendationCompany.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationCompany.vue?vue&type=style&index=0&id=91432256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91432256",
  null
  
)

export default component.exports